import React, { useState, useRef, useEffect } from 'react';
import { safeHTML } from '../../../../utils/safeHTML';
import CustomButton from '../../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { Reorder } from 'framer-motion';
import QuizItemReorderItem from './QuizItemReorderItem';
import { shuffle } from '../../../../utils/scene/utils/random/shuffle';
import { useModal } from '../../../../hooks/useModal';
import { nyTaskContent } from '../../../../constants/copyright';

const { afterAnswerModal } = nyTaskContent;

const QuizItemReorder = React.forwardRef(function QuizItemReorder(
  { image, text, answers, note_image, note_title, nextStep, note, setScore },
  ref,
) {
  const [activeId, setActiveId] = useState(null);
  const [items, setItems] = useState(shuffle([...answers]));
  const captionRef = useRef();
  const captionSpanRef = useRef();
  const { addModal } = useModal();

  const nextStepLogic = () => {
    const answerValue = items.map((el) => el.id);

    const successCallback = () => {
      setScore(answerValue);
      nextStep();
    };

    addModal({
      props: {
        ...afterAnswerModal,
        image: note_image,
        title: note_title,
        description: note,
        goToQuiz: successCallback,
        onClose: successCallback,
      },
    });
  };

  useEffect(() => {
    const caption = captionRef.current;
    const scale = Math.min(1, caption.clientHeight / caption.scrollHeight);
    if (scale < 1) captionSpanRef.current.style.fontSize = `${scale}em`;
  }, []);

  return (
    <div className={'quiz__item quiz__item_reorder'} ref={ref}>
      <div className={'quiz__item-image'}>
        <img src={image} alt={''} />
      </div>
      <div className={'quiz__item-block'}>
        <h2 className='quiz__item-title' ref={captionRef}>
          <span ref={captionSpanRef}>{safeHTML(text)}</span>
        </h2>
        <div className='quiz__item-items'>
          <Reorder.Group axis='y' onReorder={setItems} values={items}>
            {items?.map((item, id) => (
              <QuizItemReorderItem key={id} id={item.id} item={item} activeId={activeId} setActiveId={setActiveId} />
            ))}
          </Reorder.Group>
        </div>
        <CustomButton
          className={classNames('button_quiz-a quiz__item-button', {})}
          text={'other.reply'}
          disposable={true}
          onClick={nextStepLogic}
        />
      </div>
    </div>
  );
});

export default QuizItemReorder;
QuizItemReorder.propTypes = {};
